import type { FaireProductEntity } from "../../entity_types/product";

export const p_rmyvjc7m4y: FaireProductEntity = {
  token: "p_rmyvjc7m4y",
  type: "product",
  name: "Tile Collector Butter Blanket",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/8150ac0829b5ee5a45797721b7bd2aad314f6ed083edf683cc46fb7753865570.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/113cf13d8504be3ec8b1e62516648d6e326584bb82e8459c3cd3f00e991b25de.jpeg"
  ],
  priceDollars: 59.5,
  description: "Butter Blankets\n\nEverything’s better with butter.\n\n\n\nLight and compact, but oh, so soft and silky. Our Butter Blanket is perfect for throwing around your house or tucking inside your travel bag. Created from post-consumer recycled products and engineered for optimal performance, your cuddle game has never been butter.\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * Available in 50\" x 60\" or 60\" x 80\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\nSleep Responsibly.\n\nWith its natural silky softness, our Butter Blankets are guaranteed to be your new favorite cuddle buddy. The best part? They’re also friendly to the environment. Our blankets are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And since it’s engineered to perform for years, you’re sure to hang on to it, helping to reduce yours.\n",
  tags: [],
  msrpDollars: 119,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:41.975Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
